module.exports = __webpack_public_path__ + "static/media/recept-1.a63ba906.jpg";